import { Input } from 'alurkerja-ui';
import React from 'react';
import { FormField, IFormField } from './FormField';

export const TextAreaField: React.FC<IFormField> = props => {
  return (
    <FormField
      {...props}
      render={({ field }) => (
        <Input
          id={props.name}
          defaultValue={field.value}
          onChange={e => field.onChange(e.target.value)}
          disabled={props.disabled}
          textArea
        />
      )}
    />
  );
};
